import React, { useState, useContext } from 'react';

import { CheckoutErrorBoundary } from 'ggApp/modules/newCheckout/components/ErrorBoundary';
import AnimatedContainer from 'ggApp/modules/stepsFlowProvider/components/AnimatedContainer';
import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';
import { TransitionDirection } from 'ggApp/modules/stepper/utils/enums';

import { StepContainer, ProductsInCartContent } from './styles';

const CheckoutStep = ({
    component: Form,
    componentProps,
    flowName,
    nethone,
    closeCheckout,
    send,
    current,
}) => {
    const [preflight, setPreflight] = useState(false);
    const [paymentTermsInfo, setPaymentTermsInfo] = useState(null);
    const { formSubmitting, phoneVerificationConfirmError, addressError } = useContext(
        OrderContext,
    );
    const withProductsInCartContent =
        componentProps.productsInCart && !preflight && !paymentTermsInfo;

    return (
        <CheckoutErrorBoundary errorAttributes={{ feature: 'checkout', step: componentProps.name }}>
            <StepContainer>
                {withProductsInCartContent && (
                    <ProductsInCartContent className="productInCheckout" />
                )}

                <AnimatedContainer
                    animationKey={formSubmitting ? 'loader' : ''}
                    transitionDirection={
                        phoneVerificationConfirmError || addressError
                            ? TransitionDirection.backward
                            : TransitionDirection.forward
                    }
                >
                    {formSubmitting ? (
                        <CircleLoader />
                    ) : (
                        <Form
                            name={componentProps.name}
                            stepData={componentProps}
                            flowName={flowName}
                            nethone={nethone}
                            preflightActive={preflight}
                            setPreflight={setPreflight}
                            paymentTermsInfo={paymentTermsInfo}
                            setPaymentTermsInfo={setPaymentTermsInfo}
                            closeCheckout={closeCheckout}
                            send={send}
                            current={current}
                        />
                    )}
                </AnimatedContainer>
            </StepContainer>
        </CheckoutErrorBoundary>
    );
};

export default CheckoutStep;
